<template>
  <div>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="thisMonth"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
      <app-select
        @input="onChangeFilter"
        @search="onSupplierSearch"
        v-model="filter_supplier"
        :options="supplier_options"
        label="trade_name"
        placeholder="Supplier"
        class="select--300"
      />
      <app-filters
        v-model="filter_paid"
        :filters="filter_paid_options"
        name="filterPaid"
        @change="onChangeFilter"
      />
    </app-cells>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells><h2 class="title">Bank</h2></app-cells>
      <v-client-table
        :data="table_bank.items"
        :columns="table_bank.columns"
        :options="table_bank.options"
        class="table-default"
        :class="{ 'table-default--loading': table_bank_preloader }"
      >
        <template #h__supplier><div class="table-default__left">Supplier</div></template>
        <template #h__select>
          <label
            v-if="table_bank.items.length"
            class="checkbox checkbox--table"
            :class="{ 'checkbox--readonly': checked_gepg.length || checked_mobile.length || checked_cash.length }"
          >
            <input
              v-model="checked_all_bank"
              type="checkbox"
              name="checked_all"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #select="{ row }">
          <label
            class="checkbox checkbox--table"
            :class="{ 'checkbox--readonly': checked_gepg.length || checked_mobile.length || checked_cash.length }"
          >
            <input
              v-model="checked_bank"
              type="checkbox"
              :value="row"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #type="{ row }">
          <span v-if="row.type === 'deposit'" :style="{ 'backgroundColor': '#439ad1' }" class="status-tag">
            {{ row.type[0].toUpperCase() + row.type.slice(1) }}
          </span>
          <span v-if="row.type === 'final'" :style="{ 'backgroundColor': '#77b017' }" class="status-tag">
            {{ row.type[0].toUpperCase() + row.type.slice(1) }}
          </span>
        </template>
        <template #date="{ row }">
          <span v-if="row.category === 'overdue'" :style="{ 'backgroundColor': '#e85c20' }" class="status-tag">
            {{ dateFormat(row.date) }}
          </span>
          <span v-if="row.category === 'upcoming'" :style="{ 'backgroundColor': '#439ad1' }" class="status-tag">
            {{ dateFormat(row.date) }}
          </span>
          <template v-if="!row.category">
            {{ dateFormat(row.date) }}
          </template>
        </template>
        <template #amount="{ row }">
          {{ amountFormat(row.amount) }} {{ row.invoice.currency.code }}
        </template>
        <template #supplier="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'administrative-suppliers-detail-purchases', params: { id: row.invoice.supplier.id } }"
              class="table-default__link-inline"
            >
              {{ row.invoice.supplier.legal_name }}
            </router-link>
          </div>
        </template>
        <template #account="{ row }">
          <template v-if="row.invoice.supplier_payment_method.bank_account">
            {{ row.invoice.supplier_payment_method.bank_account.account_number }}<br>{{ row.invoice.supplier_payment_method.bank_account.bank.short_name }}
          </template>
          <template v-else>-</template>
        </template>
        <template #invoice_number="{ row }">{{ row.invoice.invoice_number || '-' }}</template>
        <template #invoice_date="{ row }">{{ dateFormat(row.invoice.date) }}</template>
        <template #attachment="{ row }">
          <div class="table-default__controls">
            <a
              :href="row.invoice.attachment?.file"
              target="_blank"
              :class="{'table-default__disabled': !row.invoice.attachment}"
            >
              <img src="@/assets/img/snacks-link.svg" alt="Attachment">
            </a>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationBank"
            v-if="pagination_bank.pages > 1"
            v-model="pagination_bank.page"
            :page-count="pagination_bank.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_bank.count" :count="table_bank.items.length" :page="pagination_bank.page" />
      </app-cells>
      <template v-if="table_gepg.items.length">
        <app-cells><h2 class="title">GePG</h2></app-cells>
        <v-client-table
          :data="table_gepg.items"
          :columns="table_gepg.columns"
          :options="table_gepg.options"
          class="table-default"
          :class="{ 'table-default--loading': table_gepg_preloader }"
        >
          <template #h__supplier><div class="table-default__left">Supplier</div></template>
          <template #h__select>
            <label
              v-if="table_gepg.items.length"
              class="checkbox checkbox--table"
              :class="{ 'checkbox--readonly': checked_bank.length || checked_mobile.length || checked_cash.length }"
            >
              <input
                v-model="checked_all_gepg"
                type="checkbox"
                name="checked_all"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #select="{ row }">
            <label
              class="checkbox checkbox--table"
              :class="{ 'checkbox--readonly': checked_bank.length || checked_mobile.length || checked_cash.length }"
            >
              <input
                v-model="checked_gepg"
                type="checkbox"
                :value="row"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #type="{ row }">
          <span v-if="row.type === 'deposit'" :style="{ 'backgroundColor': '#439ad1' }" class="status-tag">
            {{ row.type[0].toUpperCase() + row.type.slice(1) }}
          </span>
            <span v-if="row.type === 'final'" :style="{ 'backgroundColor': '#77b017' }" class="status-tag">
            {{ row.type[0].toUpperCase() + row.type.slice(1) }}
          </span>
          </template>
          <template #date="{ row }">
          <span v-if="row.category === 'overdue'" :style="{ 'backgroundColor': '#e85c20' }" class="status-tag">
            {{ dateFormat(row.date) }}
          </span>
            <span v-if="row.category === 'upcoming'" :style="{ 'backgroundColor': '#439ad1' }" class="status-tag">
            {{ dateFormat(row.date) }}
          </span>
            <template v-if="!row.category">
              {{ dateFormat(row.date) }}
            </template>
          </template>
          <template #amount="{ row }">
            {{ amountFormat(row.amount) }} {{ row.invoice.currency.code }}
          </template>
          <template #supplier="{ row }">
            <div class="table-default__left">
              <router-link
                :to="{ name: 'administrative-suppliers-detail-purchases', params: { id: row.invoice.supplier.id } }"
                class="table-default__link-inline"
              >
                {{ row.invoice.supplier.legal_name }}
              </router-link>
            </div>
          </template>
          <template #account="{ row }">
            <template v-if="row.invoice.gepg_number">{{ row.invoice.gepg_number }}</template>
            <template v-else>-</template>
          </template>
          <template #invoice_number="{ row }">{{ row.invoice.invoice_number || '-' }}</template>
          <template #invoice_date="{ row }">{{ dateFormat(row.invoice.date) }}</template>
          <template #attachment="{ row }">
            <div class="table-default__controls">
              <a
                :href="row.invoice.attachment?.file"
                target="_blank"
                :class="{'table-default__disabled': !row.invoice.attachment}"
              >
                <img src="@/assets/img/snacks-link.svg" alt="Attachment">
              </a>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationGepg"
              v-if="pagination_gepg.pages > 1"
              v-model="pagination_gepg.page"
              :page-count="pagination_gepg.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_gepg.count" :count="table_gepg.items.length" :page="pagination_gepg.page" />
        </app-cells>
      </template>
      <template v-if="table_mobile.items.length">
        <app-cells><h2 class="title">Mobile</h2></app-cells>
        <v-client-table
          :data="table_mobile.items"
          :columns="table_mobile.columns"
          :options="table_mobile.options"
          class="table-default"
          :class="{ 'table-default--loading': table_mobile_preloader }"
        >
          <template #h__supplier><div class="table-default__left">Supplier</div></template>
          <template #h__select>
            <label
              v-if="table_mobile.items.length"
              class="checkbox checkbox--table"
              :class="{ 'checkbox--readonly': checked_bank.length || checked_gepg.length || checked_cash.length }"
            >
              <input
                v-model="checked_all_mobile"
                type="checkbox"
                name="checked_all"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #select="{ row }">
            <label
              class="checkbox checkbox--table"
              :class="{ 'checkbox--readonly': checked_bank.length || checked_gepg.length || checked_cash.length }"
            >
              <input
                v-model="checked_mobile"
                type="checkbox"
                :value="row"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #type="{ row }">
          <span v-if="row.type === 'deposit'" :style="{ 'backgroundColor': '#439ad1' }" class="status-tag">
            {{ row.type[0].toUpperCase() + row.type.slice(1) }}
          </span>
            <span v-if="row.type === 'final'" :style="{ 'backgroundColor': '#77b017' }" class="status-tag">
            {{ row.type[0].toUpperCase() + row.type.slice(1) }}
          </span>
          </template>
          <template #date="{ row }">
          <span v-if="row.category === 'overdue'" :style="{ 'backgroundColor': '#e85c20' }" class="status-tag">
            {{ dateFormat(row.date) }}
          </span>
            <span v-if="row.category === 'upcoming'" :style="{ 'backgroundColor': '#439ad1' }" class="status-tag">
            {{ dateFormat(row.date) }}
          </span>
            <template v-if="!row.category">
              {{ dateFormat(row.date) }}
            </template>
          </template>
          <template #amount="{ row }">
            {{ amountFormat(row.amount) }} {{ row.invoice.currency.code }}
          </template>
          <template #supplier="{ row }">
            <div class="table-default__left">
              <router-link
                :to="{ name: 'administrative-suppliers-detail-purchases', params: { id: row.invoice.supplier.id } }"
                class="table-default__link-inline"
              >
                {{ row.invoice.supplier.legal_name }}
              </router-link>
            </div>
          </template>
          <template #account="{ row }">
            <template v-if="row.invoice.supplier_payment_method.mobile_account">
              {{ row.invoice.supplier_payment_method.mobile_account.account_number }}<br>{{ row.invoice.supplier_payment_method.mobile_account.provider.name }}
            </template>
            <template v-else>-</template>
          </template>
          <template #invoice_number="{ row }">{{ row.invoice.invoice_number || '-' }}</template>
          <template #invoice_date="{ row }">{{ dateFormat(row.invoice.date) }}</template>
          <template #attachment="{ row }">
            <div class="table-default__controls">
              <a
                :href="row.invoice.attachment?.file"
                target="_blank"
                :class="{'table-default__disabled': !row.invoice.attachment}"
              >
                <img src="@/assets/img/snacks-link.svg" alt="Attachment">
              </a>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationMobile"
              v-if="pagination_mobile.pages > 1"
              v-model="pagination_mobile.page"
              :page-count="pagination_mobile.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_mobile.count" :count="table_mobile.items.length" :page="pagination_mobile.page" />
        </app-cells>
      </template>
      <template v-if="table_cash.items.length">
        <app-cells><h2 class="title">Cash</h2></app-cells>
        <v-client-table
          :data="table_cash.items"
          :columns="table_cash.columns"
          :options="table_cash.options"
          class="table-default"
          :class="{ 'table-default--loading': table_cash_preloader }"
        >
          <template #h__supplier><div class="table-default__left">Supplier</div></template>
          <template #h__select>
            <label
              v-if="table_cash.items.length"
              class="checkbox checkbox--table"
              :class="{ 'checkbox--readonly': checked_gepg.length || checked_mobile.length || checked_bank.length }"
            >
              <input
                v-model="checked_all_cash"
                type="checkbox"
                name="checked_all"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #select="{ row }">
            <label
              class="checkbox checkbox--table"
              :class="{ 'checkbox--readonly': checked_gepg.length || checked_mobile.length || checked_bank.length }"
            >
              <input
                v-model="checked_cash"
                type="checkbox"
                :value="row"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #type="{ row }">
          <span v-if="row.type === 'deposit'" :style="{ 'backgroundColor': '#439ad1' }" class="status-tag">
            {{ row.type[0].toUpperCase() + row.type.slice(1) }}
          </span>
            <span v-if="row.type === 'final'" :style="{ 'backgroundColor': '#77b017' }" class="status-tag">
            {{ row.type[0].toUpperCase() + row.type.slice(1) }}
          </span>
          </template>
          <template #date="{ row }">
          <span v-if="row.category === 'overdue'" :style="{ 'backgroundColor': '#e85c20' }" class="status-tag">
            {{ dateFormat(row.date) }}
          </span>
            <span v-if="row.category === 'upcoming'" :style="{ 'backgroundColor': '#439ad1' }" class="status-tag">
            {{ dateFormat(row.date) }}
          </span>
            <template v-if="!row.category">
              {{ dateFormat(row.date) }}
            </template>
          </template>
          <template #amount="{ row }">
            {{ amountFormat(row.amount) }} {{ row.invoice.currency.code }}
          </template>
          <template #supplier="{ row }">
            <div class="table-default__left">
              <router-link
                :to="{ name: 'administrative-suppliers-detail-purchases', params: { id: row.invoice.supplier.id } }"
                class="table-default__link-inline"
              >
                {{ row.invoice.supplier.legal_name }}
              </router-link>
            </div>
          </template>
          <template #invoice_number="{ row }">{{ row.invoice.invoice_number || '-' }}</template>
          <template #invoice_date="{ row }">{{ dateFormat(row.invoice.date) }}</template>
          <template #attachment="{ row }">
            <div class="table-default__controls">
              <a
                :href="row.invoice.attachment?.file"
                target="_blank"
                :class="{'table-default__disabled': !row.invoice.attachment}"
              >
                <img src="@/assets/img/snacks-link.svg" alt="Attachment">
              </a>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationCash"
              v-if="pagination_cash.pages > 1"
              v-model="pagination_cash.page"
              :page-count="pagination_cash.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_cash.count" :count="table_cash.items.length" :page="pagination_cash.page" />
        </app-cells>
      </template>
      <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
        <div class="flying-block__text">
          Selected plans:
          <template v-if="checked_bank.length"><span>{{ checked_bank.length }}</span></template>
          <template v-if="checked_gepg.length"><span>{{ checked_gepg.length }}</span></template>
          <template v-if="checked_mobile.length"><span>{{ checked_mobile.length }}</span></template>
          <template v-if="checked_cash.length"><span>{{ checked_cash.length }}</span></template>
        </div>
        <app-button @click.native="onShowModal">Create transaction</app-button>
      </div>
    </template>
    <modal
      name="transaction-modal"
      :width="800"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('transaction-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Add transaction</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm" class="arrange-popup">
            <app-grid>
              <template #item-1>
                <app-form-group label="Account" required >
                  <app-select
                    v-model="form.account"
                    :options="account_options"
                    :clearable="false"
                    placeholder="Account"
                    :error="$v.form.account.$error"
                  >
                  </app-select>
                  <template #error>
                    <div v-if="$v.form.account.$dirty && !$v.form.account.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Date" required>
                  <app-date-picker
                    v-model="form.date"
                    placeholder="Specify a date"
                    :error="$v.form.date.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.date.$dirty && !$v.form.date.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
              <template #item-2>
                <app-form-group v-if="form.account?.reference" label="Reference" label-for="reference" required>
                  <app-input
                    v-model="form.reference"
                    id="reference"
                    name="reference"
                    placeholder="Reference"
                    :error="$v.form.reference.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.reference.$dirty && !$v.form.reference.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Responsible">
                  <app-select
                    v-model="form.responsible"
                    :options="employee_options"
                    label="full_name"
                    placeholder="Responsible"
                  >
                  </app-select>
                </app-form-group>
              </template>
            </app-grid>
            <div class="arrange-popup__part">
              <div class="arrange-popup__block-title arrange-popup__block-title--fz13"><span>Items</span></div>
              <div class="transfer-sortable transfer-sortable--cashflow transfer-sortable--full">
                <div v-for="(element, index) in form.items" :key="`own_item_${index}`" class="transfer-sortable__item transfer-sortable__item--mb-20" style="padding: 12px 16px">
                  <app-flex-grid :rows="[['150px', 1, '100px', 1]]" margin-bottom="0">
                    <template #col-1-1>
                      <app-form-field label="Accounting">
                        <app-date-picker
                          v-model="element.accounting"
                          type="month"
                          format="MMM YYYY"
                          readonly
                          placeholder="Specify a date"
                        />
                      </app-form-field>
                    </template>
                    <template #col-1-2>
                      <app-form-field label="Supplier">
                        <app-select
                          v-model="element.supplier"
                          label="trade_name"
                          placeholder="Supplier"
                          readonly
                        >
                        </app-select>
                      </app-form-field>
                    </template>
                    <template #col-1-3>
                      <app-form-field label="Amount" :label-for="`amount-${index}`">
                        <app-fin-number
                          v-model="element.amount"
                          :id="`amount-${index}`"
                          placeholder="0"
                          name="amount"
                          readonly
                        />
                      </app-form-field>
                    </template>
                    <template #col-1-4>
                      <app-form-field label="Transaction item">
                        <app-select
                          v-model="element.item"
                          label="name_expense"
                          placeholder="Transaction item"
                          readonly
                        >
                        </app-select>
                      </app-form-field>
                    </template>
                  </app-flex-grid>
                </div>
              </div>
            </div>
            <app-form-group label="Notes" label-for="description">
              <app-textarea
                v-model="form.description"
                rows="5"
                placeholder="Write a note"
                id="description"
                name="description"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="submit">Add</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { required, requiredIf } from 'vuelidate/lib/validators'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import {
  getAdministrativeSuppliers,
  getEmployeesListSearch,
  getFinanceAccounts,
  getFinanceSupplierInvoicePaymentPlanList,
  getFinanceTransactionsItemsList,
  postFinanceCashflow,
} from '@/http'
import debounce from 'lodash/debounce'

export default {
  name: 'FinanceSupplierInvoicesPaymentPlan',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      page_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      custom_shortcuts: [
        { key: 'thisMonth', label: 'This month', value: 'month' },
        { key: 'lastMonth', label: 'Last month', value: '-month' },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
      supplier_options: [],
      filter_supplier: null,
      filter_paid: '',
      filter_paid_options: [
        { value: '', label: 'Unpaid' },
        { value: 'paid', label: 'Paid' },
      ],
      table_bank: {
        items: [],
        columns: [
          'select',
          'type',
          'date',
          'amount',
          'supplier',
          'account',
          'invoice_number',
          'invoice_date',
          'attachment',
        ],
        options: {
          headings: {
            'select': '',
            'type': 'Type',
            'date': 'Date',
            'amount': 'Amount',
            'supplier': 'Supplier',
            'account': 'Account',
            'invoice_number': 'Invoice number',
            'invoice_date': 'Invoice date',
            'attachment': 'Attachment',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_bank: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_bank_preloader: false,
      table_gepg: {
        items: [],
        columns: [
          'select',
          'type',
          'date',
          'amount',
          'supplier',
          'account',
          'invoice_number',
          'invoice_date',
          'attachment',
        ],
        options: {
          headings: {
            'select': '',
            'type': 'Type',
            'date': 'Date',
            'amount': 'Amount',
            'supplier': 'Supplier',
            'account': 'Account',
            'invoice_number': 'Invoice number',
            'invoice_date': 'Invoice date',
            'attachment': 'Attachment',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_gepg: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_gepg_preloader: false,
      table_mobile: {
        items: [],
        columns: [
          'select',
          'type',
          'date',
          'amount',
          'supplier',
          'account',
          'invoice_number',
          'invoice_date',
          'attachment',
        ],
        options: {
          headings: {
            'select': '',
            'type': 'Type',
            'date': 'Date',
            'amount': 'Amount',
            'supplier': 'Supplier',
            'account': 'Account',
            'invoice_number': 'Invoice number',
            'invoice_date': 'Invoice date',
            'attachment': 'Attachment',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_mobile: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_mobile_preloader: false,
      table_cash: {
        items: [],
        columns: [
          'select',
          'type',
          'date',
          'amount',
          'supplier',
          'invoice_number',
          'invoice_date',
          'attachment',
        ],
        options: {
          headings: {
            'select': '',
            'type': 'Type',
            'date': 'Date',
            'amount': 'Amount',
            'supplier': 'Supplier',
            'invoice_number': 'Invoice number',
            'invoice_date': 'Invoice date',
            'attachment': 'Attachment',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_cash: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_cash_preloader: false,
      checked_all_bank: false,
      checked_all_gepg: false,
      checked_all_mobile: false,
      checked_all_cash: false,
      checked_bank: [],
      checked_gepg: [],
      checked_mobile: [],
      checked_cash: [],
      is_show_flying_block: false,
      form: {},
      account_options: [],
      employee_options: [],
      transaction_items_options: [],
      items_field: '',
    }
  },
  validations: {
    form: {
      account: { required },
      date: { required },
      reference: {
        required: requiredIf(function() {
          return this.form.account?.reference
        })
      },
    },
  },
  computed: {
    allChecked() {
      return [...this.checked_bank, ...this.checked_gepg, ...this.checked_mobile, ...this.checked_cash]
    }
  },
  watch: {
    checked_all_bank(value) {
      if (value) {
        this.table_bank.items.forEach(item => {
          if (!this.checked_bank.map(item => item.id).includes(item.id)) this.checked_bank.push(item)
        })
      } else {
        this.checked_bank = []
      }
    },
    checked_bank(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_bank.length) this.checked_all_bank = false
    },
    checked_all_gepg(value) {
      if (value) {
        this.table_gepg.items.forEach(item => {
          if (!this.checked_gepg.map(item => item.id).includes(item.id)) this.checked_gepg.push(item)
        })
      } else {
        this.checked_gepg = []
      }
    },
    checked_gepg(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_gepg.length) this.checked_all_gepg = false
    },
    checked_all_mobile(value) {
      if (value) {
        this.table_mobile.items.forEach(item => {
          if (!this.checked_mobile.map(item => item.id).includes(item.id)) this.checked_mobile.push(item)
        })
      } else {
        this.checked_mobile = []
      }
    },
    checked_mobile(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_mobile.length) this.checked_all_mobile = false
    },
    checked_all_cash(value) {
      if (value) {
        this.table_cash.items.forEach(item => {
          if (!this.checked_cash.map(item => item.id).includes(item.id)) this.checked_cash.push(item)
        })
      } else {
        this.checked_cash = []
      }
    },
    checked_cash(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_cash.length) this.checked_all_cash = false
    },
  },
  mounted() {
    Promise.all([
      getFinanceAccounts({ outcome: true }),
      getEmployeesListSearch({ status: 'working_resident' }),
      getFinanceTransactionsItemsList({ expense: true }),
      this.fetchItemsBank(),
      this.fetchItemsGepg(),
      this.fetchItemsMobile(),
      this.fetchItemsCash()
    ])
      .then(res => {
        this.account_options = res[0].data
        this.employee_options = res[1].data
        this.transaction_items_options = res[2].data
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsBank() {
      this.table_bank_preloader = true
      const response = await getFinanceSupplierInvoicePaymentPlanList({
        page: this.pagination_bank.page,
        page_size: 20,
        account_category: 'bank',
        supplier: this.filter_supplier?.id,
        date_from: this.filter_dates?.start,
        date_to: this.filter_dates?.end,
        paid: !!this.filter_paid,
      })
      this.table_bank.items = response.data.results
      this.pagination_bank.pages = response.data.pages
      this.pagination_bank.count = response.data.count
      this.table_bank_preloader = false
    },
    async fetchItemsGepg() {
      this.table_gepg_preloader = true
      const response = await getFinanceSupplierInvoicePaymentPlanList({
        page: this.pagination_gepg.page,
        page_size: 20,
        account_category: 'gepg',
        supplier: this.filter_supplier?.id,
        date_from: this.filter_dates?.start,
        date_to: this.filter_dates?.end,
        paid: !!this.filter_paid,
      })
      this.table_gepg.items = response.data.results
      this.pagination_gepg.pages = response.data.pages
      this.pagination_gepg.count = response.data.count
      this.table_gepg_preloader = false
    },
    async fetchItemsMobile() {
      this.table_mobile_preloader = true
      const response = await getFinanceSupplierInvoicePaymentPlanList({
        page: this.pagination_mobile.page,
        page_size: 20,
        account_category: 'mobile',
        supplier: this.filter_supplier?.id,
        date_from: this.filter_dates?.start,
        date_to: this.filter_dates?.end,
        paid: !!this.filter_paid,
      })
      this.table_mobile.items = response.data.results
      this.pagination_mobile.pages = response.data.pages
      this.pagination_mobile.count = response.data.count
      this.table_mobile_preloader = false
    },
    async fetchItemsCash() {
      this.table_cash_preloader = true
      const response = await getFinanceSupplierInvoicePaymentPlanList({
        page: this.pagination_cash.page,
        page_size: 20,
        account_category: 'cash',
        supplier: this.filter_supplier?.id,
        date_from: this.filter_dates?.start,
        date_to: this.filter_dates?.end,
        paid: !!this.filter_paid,
      })
      this.table_cash.items = response.data.results
      this.pagination_cash.pages = response.data.pages
      this.pagination_cash.count = response.data.count
      this.table_cash_preloader = false
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchTables()
      } else this.date_picker_error = true
    },
    fetchTables() {
      this.fetchItemsBank()
      this.fetchItemsGepg()
      this.fetchItemsMobile()
      this.fetchItemsCash()
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      const formData = {...this.form}
      formData.type = 2
      formData.account = formData.account.id
      if (formData.responsible) formData.responsible = formData.responsible.id
      formData.items = formData.items.map(({amount, item, supplier, id, accounting}) => {
        return {
          payment_plan: id,
          accounting,
          amount,
          supplier: supplier.id,
          item: item.id,
        }
      })
      postFinanceCashflow(formData)
        .then(() => {
          this.fetchTables()
          this.$notify({
            type: 'success',
            title: 'Transaction created',
          })
          this.$modal.hide('transaction-modal')
          this.checked_bank = []
          this.checked_gepg = []
          this.checked_mobile = []
          this.checked_cash = []
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    onShowModal() {
      this.form = {
        date: format(new Date(), 'yyyy-MM-dd'),
        items: this.allChecked
          .map(({ amount, id, invoice }) => {
            return {
              amount,
              accounting: invoice.accounting,
              id,
              supplier: invoice.supplier,
              item: invoice.transaction_item,
            }
          })
      }
      this.$v.form.$reset()
      this.$modal.show('transaction-modal')
    },
    onChangeFilter(e) {
      if (e) {
        this.table_bank.columns.shift()
        this.table_gepg.columns.shift()
        this.table_mobile.columns.shift()
        this.table_cash.columns.shift()
      } else {
        this.table_bank.columns.unshift('select')
        this.table_gepg.columns.unshift('select')
        this.table_mobile.columns.unshift('select')
        this.table_cash.columns.unshift('select')
      }
      this.pagination_bank.page = 1
      this.pagination_mobile.page = 1
      this.pagination_gepg.page = 1
      this.pagination_cash.page = 1
      this.fetchTables()
    },
    onClickPaginationBank(page) {
      this.pagination_bank.page = page
      this.fetchItemsBank()
    },
    onClickPaginationMobile(page) {
      this.pagination_mobile.page = page
      this.fetchItemsMobile()
    },
    onClickPaginationGepg(page) {
      this.pagination_gepg.page = page
      this.fetchItemsGepg()
    },
    onClickPaginationCash(page) {
      this.pagination_cash.page = page
      this.fetchItemsCash()
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
    amountFormat(amount) {
      return new Intl.NumberFormat('ru-RU').format(amount)
    },
    onSupplierSearch(search, loading) {
      loading(true)
      this.searchSupplier(loading, search, this)
    },
    searchSupplier: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_options = []
      } else {
        getAdministrativeSuppliers({search}).then(response => {
          vm.supplier_options = response.data
          loading(false)
        })
      }
    }, 350),
  },
}
</script>
